'use client';

import Spinner from '@/components/ui/spinner';
import { useCurrentUser } from '@/features/auth/hooks/use-current-user';
import { AuthenticatedActions } from './authenticated-actions';
import { UnAuthenticatedActions } from './unauthenticated-actions';
export default function Actions() {
  const {
    data: user,
    isPending
  } = useCurrentUser();
  if (isPending) {
    return <div className="ml-auto">
        <Spinner color="black" />
      </div>;
  }
  return <ul className="ml-auto flex items-center gap-4" data-sentry-component="Actions" data-sentry-source-file="index.tsx">
      {user ? <AuthenticatedActions /> : <UnAuthenticatedActions />}
    </ul>;
}